<template>
  <v-list>
    <template v-for="(item, index) in items">
      <v-divider v-if="item.divider" :key="index"></v-divider>
      <v-list-item
        v-if="item.visible !== false && !item.divider"
        :key="item.text"
        :to="item.to"
        :disabled="item.disabled"
        :inactive="item.disabled"
      >
        <v-list-item-action>
          <v-badge
            v-if="item.notificacoes || (item.badge && $store.state.rodada.id)"
            bordered
            dot
            color="error"
            :content="item.notificacoes || ''"
            :value="item.notificacoes"
            overlap
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-badge>
          <v-icon v-else>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.subtext }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-list-item href="/chrome/ChromeStandaloneSetup.exe" v-if="!isChrome">
      <v-list-item-action>
        <v-icon>mdi-google-chrome</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Google Chrome</v-list-item-title>
        <v-list-item-subtitle>Download</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "menu-representante",
  props: {
    notificacoes: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isChrome() {
      return (
        navigator.userAgent.match(/edg/i) ||
        navigator.userAgent.match(/chrome|chromium|crios/i)
      );
    },
    items() {
      return [
        {
          text: "Página Inicial",
          icon: "mdi-chart-areaspline",
          to: "/dashboard",
          disabled: false,
          visible: !!this.$store.state.rodada.id,
        },
        { text: "Loja", icon: "mdi-storefront", to: "/", disabled: false },
        {
          text: "Rodadas de Negócio",
          icon: "mdi-bullseye",
          to: "/rodadas",
          disabled: false,
          badge: true,
        },
        {
          text: "Mapa dos Stands",
          icon: "mdi-map",
          to: `/mapa-stands/${this.$store.state.rodada.id}`,
          disabled: false,
          badge: false,
          visible: !!this.$store.state.rodada.id,
        },
        // {
        //   text: "Agenda",
        //   subtext: "Rodada de Negócios",
        //   icon: "mdi-rhombus-split",
        //   to: "/agenda",
        //   disabled: false,
        // },
        { text: "Clientes", icon: "group", to: "/clientes", disabled: false },
        {
          text: "Pedidos",
          icon: "description",
          to: "/pedidos",
          disabled: false,
        },
        {
          text: "Fornecedores",
          icon: "people_outline",
          to: "/fornecedores",
          disabled: false,
        },
        /* {
          text: "Entregas",
          icon: "local_shipping",
          to: "/representantes/entregas",
          disabled: false,
        }, */
        {
          text: "Notificações",
          icon: "notifications",
          to: "/notificacoes",
          disabled: false,
          badge: true,
          notificacoes: 0,
        },
        /* {
          text: "Financeiro",
          icon: "monetization_on",
          to: "/financeiro",
          disabled: false,
        },
        {
          text: "Faturamento",
          icon: "group_work",
          to: "/faturamento",
          disabled: false,
        }, */
        {
          text: "Remessas",
          icon: "mdi-truck-delivery",
          to: "/remessas",
          disabled: false,
        },
        {
          text: "Comissões",
          icon: "mdi-currency-usd",
          to: "/comissoes",
          disabled: false,
        },
        { divider: true },
        {
          text: "Relatórios",
          icon: "mdi-file-chart",
          to: "/relatorios",
          disabled: false,
        },
        {
          text: "Ajuda",
          icon: "mdi-help-circle",
          to: "/ajuda",
          disabled: true,
          visible: false,
        },
      ];
    },
  },
  watch: {
    notificacoes: function(value) {
      const notif = this.items.find((item) => item.text === "Notificações");
      notif.notificacoes = this.notificacoes;
    },
  },
};
</script>

<style lang="scss" scoped></style>
